import mixinTrackerSession from 'shared/mixins/tracker-session';
import {searchToObject} from 'shared/javascripts/url-helpers';

const trackerMixin = {
  mixins: [mixinTrackerSession],
  data: () => ({
    source: null,
    prevRoute: null,
    pageVisitTime: 0,
  }),
  watch: {
    $route: {
      handler(to, from) {
        if (from.name) this.sendLeaveTracker({routeName: from.name});
        this.pageVisitTime = new Date().getTime();
        this.prevRoute = from.name;
      },
      deep: true,
    },
  },
  created() {
    this.mixinSyncSessionId();
  },
  methods: {
    initTracker() {
      const locationSearch = searchToObject();
      const {from, source, referrer} = locationSearch;

      const directAccessTemplate = 'direct-access';
      this.source = source || from || referrer || null;

      const blReferrerFromEduKarier = document.referrer.includes(`${document.location.host}/edukarier`);

      if (!this.source) {
        const splittedPath = window.location.pathname.split('/edukarier') ?? [];
        const [fullpath] = splittedPath.slice(1);
        if (document.referrer && !blReferrerFromEduKarier) {
          this.source = document.referrer;
          this.$router.replace({path: fullpath, query: {source: document.referrer}})?.catch((e) => e);
        } else {
          this.source = directAccessTemplate;
        }
      }

      this.prevRoute = referrer || this.source;
      this.pageVisitTime = new Date().getTime();
    },
    sendLeaveTracker({routeName}) {
      const visitDuration = Math.floor((new Date().getTime() - this.pageVisitTime) / 1000);
      const payload = {
        evn: `vp_edukarier_leave`,
        event_name: routeName,
        visit_duration: visitDuration,
        ui: window.USER.id36,
        session_id: this.mixinSessionId,
      };
      return this.$tracker.event(payload);
    },
  },
};

export default trackerMixin;
